import React from 'react';
import styles from "./Styles.module.css"

const VisibilityButton = (props) => {
  const {
    visibilityButton, visibilityButtonSelected, radio, radioSelected,
  } = styles;
  const {
    data, selected, setVisibility, text,
  } = props;

  return (
    <div className={selected === data ? visibilityButtonSelected : visibilityButton}
         onClick={() => setVisibility(data)}>
      <div className={styles.font14}>
        {text}
      </div>
      <div className={styles.section}>
        <span className={selected === data ? radioSelected : radio}/>
      </div>
    </div>
  );
};

export {VisibilityButton}